import TextBox, { textBoxStyles } from 'assets/components/textBox/TextBox';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import { getClaimCreatedByApp } from 'assets/utils/other/Utils.Other.ClaimEdit';
import PayeeType from 'models/claims/payeeType/Model.PayeeType';
import dealerFindApi from 'models/dealerManagement/dealer/find/Api.Dealer.Find';
import { ClaimCreationType } from 'models/enums/ClaimCreation';
import { paragraphStyles } from '../ClaimEdit.Info';

type Props = {
  claim: Model.IClaim;
};

export default function ClaimEditContactInfo({ claim }: Props) {
  const { payload: dealer } = useApi({ action: dealerFindApi, body: { id: claim?.dealerId }, wait: !claim?.dealerId });
  const { lang } = getLocales();

  const getClaimCreatedAs = () => {
    let createdAs = undefined;

    if (claim.createdByPayee?.payeeTypeId === PayeeType.DEALER_ID) {
      if (getClaimCreatedByApp(claim) === ClaimCreationType.PUBLIC_LINK) {
        createdAs = lang.dealership;
      } else createdAs = lang.dealer;
    } else if (claim.createdByPayee?.payeeTypeId === PayeeType.REPAIR_FACILITY_ID) createdAs = lang.repairFacility;
    else if (claim.createdByPayee?.payeeTypeId === PayeeType.OTHER_ID) createdAs = lang.other;
    else if (claim.createdByPayee?.payeeTypeId === PayeeType.CLIENT_ID) createdAs = lang.customer;
    else createdAs = 'N/A';

    return createdAs;
  };

  return (
    <>
      <h2>{lang.contactInfo}</h2>
      <div style={paragraphStyles}>
        <TextBox
          class={textBoxStyles.block.flexBlock}
          title={`${lang.createdBy}:`}
          subtitle={getClaimCreatedByApp(claim)}
        />
        <TextBox class={textBoxStyles.block.flexBlock} title={`${lang.createdAs}:`} subtitle={getClaimCreatedAs()} />
        {dealer && (
          <TextBox
            class={textBoxStyles.block.flexBlock}
            title={getClaimCreatedByApp(claim) === ClaimCreationType.ASC ? `${lang.dealer}:` : `${lang.dealership}:`}
            subtitle={dealer?.name}
          />
        )}
        <TextBox
          class={textBoxStyles.block.flexBlock}
          title={`${lang.contactName}:`}
          subtitle={claim?.createdByPayee?.name ?? 'N/A'}
        />
        <TextBox
          class={textBoxStyles.block.flexBlock}
          title={`${lang.phoneNumber}:`}
          subtitle={claim?.createdByPayee?.phoneNumber ?? 'N/A'}
        />
        <TextBox
          class={textBoxStyles.block.flexBlock}
          title={`${lang.email}:`}
          subtitle={claim?.createdByPayee?.email ?? 'N/A'}
        />
      </div>
    </>
  );
}
